module.exports = "<simple-link target=\"task.event_emitter\"></simple-link> wants to join Group <simple-link target=\"task.target.group\"></simple-link>.";